import React from 'react'

import { getErrorMessage } from 'utils'

import { useSnackbar } from 'contexts'
import { useAddressMutations } from 'hooks/api'

import { Stack, Typography } from '@mui/material'

import { Modal, Button } from '@repo/ui'
import type { Address } from 'types'

interface DeleteAddressModalProps {
  address?: Address | null
  open: boolean
  onClose: () => void
  refetch: () => void
}

export const DeleteAddressModal = (props: DeleteAddressModalProps) => {
  const { address, open, onClose = () => {}, refetch } = props

  const { open: notification } = useSnackbar()
  const { remove, isRemoving } = useAddressMutations()

  const handleClose = () => {
    onClose()
  }

  const handleDeleteAddress = async () => {
    if (!address) return
    try {
      await remove({ id: address.id })
      refetch()
      handleClose()
    } catch (error) {
      notification({ type: 'error', title: getErrorMessage(error) || 'Could not delete address' })
    }
  }

  const addressName = address?.label || address?.full_name || 'this address'

  return (
    <Modal
      title="Delete address"
      open={open}
      onClose={handleClose}
      actions={
        <>
          <Button disableElevation variant="secondary" onClick={handleClose} disabled={isRemoving}>
            Cancel
          </Button>
          <Button disableElevation destructive loading={isRemoving} onClick={handleDeleteAddress}>
            Delete
          </Button>
        </>
      }
    >
      <Stack spacing={4}>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
          {`Are you sure you want to delete the address "${addressName}"? This can't be undone.`}
        </Typography>
      </Stack>
    </Modal>
  )
}
